var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 518,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 101,
    width: 519,
    height: 518
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-86 -101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.94 199.646 426.271 199.646 426.271 172.667C426.271 160.796 416.558 151.083 404.688 151.083L242.812 151.083 183.458 111.694C179.681 109.535 175.904 107.917 171.587 107.917L70.1458 107.917C58.275 107.917 48.5625 117.629 48.5625 129.5L48.5625 393.896C48.5625 394.975 118.169 225.006 118.169 225.006 124.644 209.898 139.212 199.646 155.94 199.646Z",
    transform: "matrix(1.00193 0 0 1 86 101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 242.812C469.438 231.481 461.344 222.308 450.013 221.229L155.94 221.229C147.846 221.229 140.831 226.085 137.594 233.1L64.75 410.083 393.896 410.083 467.279 252.525C468.898 249.288 469.438 246.05 469.438 242.812L469.438 242.812Z",
    transform: "matrix(1.00193 0 0 1 86 101)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDark);
export default __webpack_public_path__ + "static/media/folder_dark.3e737242212b511a21c005ec6f3c44f4.svg";
export { ForwardRef as ReactComponent };